$(document).ready(function () {
    const gtmHelpers = new GoogleTagManagerHelpers();
    let plpCount = 0;
    $(document).on("fineshedLoadPLP", function (){
        let $productCards = $(".grid__item:not(.hidden) .product-card")
        const carouselTitle = $('.collection-name').text();
        const productItemsPushed = {};
        let productsRendered = [];
        
        window.dataLayerIntervalList.push(() => {
        const productsSliced = $productCards.slice(plpCount);
        productsSliced.each((index, productCard) => {
            if (productItemsPushed[index] !== true) {
                const productItem = gtmHelpers.productItemByProductCard(productCard);
                productItemsPushed[index] = true;
                productsRendered.push({...productItem, index: index + 1, item_list_name: gtmHelpers.formatString(carouselTitle)});
                
            }
            
        });
        
        if (productsRendered.length > 0) {
            $(document).trigger('gtm-datalayer', {
            path: 'enhancedEcommerce:viewItemList',
            custom: {
                ecommerce: {
                currency : 'USD',
                items: productsRendered
                }
            }
            });
            plpCount=$productCards.length;
            productsRendered = [];
            return { ok: true}
        }
        if (Object.keys(productItemsPushed).length >= $productCards.length) {
            return {ok: true, stop: true}
        }
        return { ok: false, error: false}
        });
    })
	$(document).on('click touchstart', '.card-collection-plp', function () {
        const gtmTitle = $(this).data('gtmTitle');
		$(document).trigger('gtm-datalayer', {
			path: 'general:click',
			custom: {
				custom_type: gtmHelpers.types.icon,
				custom_title: `category-${gtmHelpers.formatString(gtmTitle)}`
			}
		});
	});

    $(document).on('click touchstart', '.collection-hero #toggleDescription', function () {
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.icon,
                custom_title: 'show-more'
            }
        });
    });
    
    $(document).on('click touchstart', '.js-filter', function (e) {
        const filterName = $(this).find('.filter-label-name').data('filterName');
		if (e.target.value) {
			$(document).trigger('gtm-datalayer', {
				path: 'general:click',
				custom: {
					custom_type: gtmHelpers.types.filter,
					custom_title: `${gtmHelpers.formatString(filterName)}:${gtmHelpers.formatString(e.target.value)}`
				}
			});
		}
    });

    $(document).on('change', '#SortBy', function () {
        const sortName = $(this).find('option:selected').data('optionName');
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.filter,
                custom_title: `order-by-${gtmHelpers.formatString(sortName)}`
            }
        });
    });

    $(document).on('click touchstart', '#apply-price-filter-btn', function () {
        const $priceParent = $(this).closest('.facets__price');
        const priceGTE = $priceParent.find('#Filter-Price-GTE').val();
        const priceLTE = $priceParent.find('#Filter-Price-LTE').val();
        let customTitle = '';
        if (priceLTE && priceGTE) {
            customTitle = `price:${gtmHelpers.formatString(priceGTE)}-${gtmHelpers.formatString(priceLTE)}`
        } else if (priceLTE && !priceGTE) {
            customTitle = `price:bellow-${gtmHelpers.formatString(priceLTE)}`
        } else if (!priceLTE && priceGTE) {
            customTitle = `price:above-${gtmHelpers.formatString(priceGTE)}`
        }
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.filter,
                custom_title: customTitle
            }
        });
    });

    
    $(document).on('click touchstart', '.filter-remove', function () {
        const filterTag = $(this).data('tag');
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.filter,
                custom_title: `remove:${gtmHelpers.formatString(filterTag)}`
            }
        });
    });

    $(document).on('click touchstart', '.filter-clean', function () {
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.filter,
                custom_title: `clean`
            }
        });
    });
});
